import { connect } from "react-redux";

function mapStateToProps(state) {
  return { users: state.users };
}

function mapDispatchToProps() {
  return {};
}

export default connect(mapStateToProps, mapDispatchToProps);
